module.exports = __webpack_public_path__ + "static/media/instagram.cd31ab28.svg";